import React from 'react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.img`
  width: 21px;
  height: 21px;
  animation: ${rotate} 1s linear infinite;
`;

export const UniversalSpinner: React.FC<{ size?: number }> = ({ size }) => {
  return (
    <Spinner
      src="/spinner.svg"
      alt=""
      draggable={false}
      style={size ? { width: size, height: size } : undefined}
    />
  );
};
